import { render, staticRenderFns } from "./GeoChartClinical.vue?vue&type=template&id=05f0e016&scoped=true"
import script from "./GeoChartClinical.vue?vue&type=script&lang=js"
export * from "./GeoChartClinical.vue?vue&type=script&lang=js"
import style0 from "./GeoChartClinical.vue?vue&type=style&index=0&id=05f0e016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f0e016",
  null
  
)

export default component.exports